import styles from '../mna-info.module.scss';
import classnames from 'classnames/bind';
import React from "react";
import {Form, Formik} from "formik";
import {CustomerMnaNeedsDto} from "../../../model/customer/dto/customer-mna-needs-dto";
import MnaIntroductionFeePolicyPop from "./mna-introduction-fee-policy-pop";
import ConnectChannelTalk from "./connect-channel-talk";
import {DialogManager} from "../../../components/dialog-manager";
import {useInjection} from "inversify-react";
import {CustomerInputApi} from "../../../model/customer/customer-input-api";
import {MnaInfoProp} from "../mna-info";
import NeedsCustomerType from "./needs-customer-type";

const cx = classnames.bind(styles);

const MnAInfo = ({data, needs, setNeeds, needsType, setNeedsType, available} : MnaInfoProp) => {
    const customerInputApi = useInjection(CustomerInputApi);
    const dialogManager = useInjection(DialogManager);

    if (!needs) return <div></div>;

    return(
        <Formik
            initialValues={{
                companyType: needsType,
            }}
            onSubmit={async (values) => {
                dialogManager.confirm(needs.type === 'CHECK' ? '저장하시겠습니까?' : '중개신청을 취소하시겠습니까?', '', async () => {
                    const result = await customerInputApi.cancelMnaNeeds(data.customer!.id);

                    if (result.success) {
                        dialogManager.alert(needs.type === 'CHECK' ? '저장되었습니다.' : "중개신청이 취소되었습니다.");

                        const dto: CustomerMnaNeedsDto = {
                            id: data.customer!.id,
                            type: "NONE",
                            createAt: needs.createAt
                        }

                        setNeeds((prevNeeds) => ({
                            ...prevNeeds,
                            id: dto.id,
                            type: dto.type,
                            isTempSave: true,
                            isApplyNeeds: false,
                            createAt: dto.createAt
                        }));

                    } else {
                        dialogManager.alert(result.message ?? needs.type === 'CHECK' ? '저장에 실패하였습니다.' : "중개신청 취소에 실패했습니다.");
                    }
                });
            }}>
            {() =>

                <div className={cx('mna-info')}>
                    <Form>
                        <div className={cx('title-line')}>
                            <p className={cx('title')}>
                                M&A 니즈
                                <button className={cx('status-btn')} type='button' onClick={() => {dialogManager.open(MnaIntroductionFeePolicyPop, {})}}>M&A 소개수수료 정책<i></i></button>
                            </p>
                            <div className={cx('btn-area')}>
                                {needs?.isApplyNeeds && <button className={cx('save-btn')} type='submit'><i></i>{needs.type === 'CHECK' ? '저장하기' : '중개신청 취소'}</button>}
                            </div>
                        </div>
                        <div className={cx('content')}>
                            <NeedsCustomerType needs={needs} needsType={needsType} setNeedsType={setNeedsType} available={available} />
                            <ConnectChannelTalk btnText='M&A 중개 문의'>
                                <p className={cx('title')}><span>M&A 니즈</span>를 가지는 고객사의 정보를 등록해 주세요.</p>
                                <p className={cx('desc')}><span>검토가능기업, 매각희망기업, 인수희망기업</span>으로 등록시, 씨오파트너 M&A센터에서<br/>씨오파트너
                                    회원에게 직접 연락드리고, M&A중개 절차를 안내해드립니다.</p>
                            </ConnectChannelTalk>
                        </div>
                    </Form>
                </div>
            }
        </Formik>
    );
}

export default MnAInfo;